// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__33Vm1","inputWrap":"CustomTip_inputWrap__2QXnN"};